module.exports = "<!--<div class=\"page-load-animation\"></div>-->\n<vr-route-handler></vr-route-handler>\n<div class=\"background\" *ngIf=\"(authGuard.loader)\">\n  <div class=\"wrapper\">\n    <div class=\"ball-scale-multiple\">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n    <!--<div class=\"loading\" i18n=\"@@Loading\">LOADING</div>-->\n  </div>\n</div>\n<!-- Everything related to Layout is found in core/layout/layout.component.ts -->\n"


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main